<ng-template #loading>
    <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
</ng-template>
<div class="card">
    <p-accordion multiple="true" (activeIndexChange)="handleOnOpen($event)" #authAccordions>
        <p-accordionTab [selected]="true" header="Filters">
            <form [formGroup]="filterFormGroup" #filterForm="ngForm" id="filterForm">
                <p-toolbar>
                    <p-floatLabel variant="on">
                        <p-multiSelect [virtualScroll]="true" [itemSize]="dropdownItemHeight"
                            *ngIf="tasksSelectItems as items; else loading" [options]="items" appendTo="body"
                            [filter]="true" maxSelectedLabels="1" selectedItemsLabel="{0} Task(s) requested."
                            formControlName="Tasks" [panelStyle]="{ width: '50em' }"
                            [style]="{ 'min-width': '15em' }"></p-multiSelect>
                        <label for="float-dd">Premium Pay Tasks</label>
                    </p-floatLabel>
                    <div>
                        <p-floatLabel variant="on">
                            <p-datepicker formControlName="PPEndDate" dataType="string" appendTo="body"
                                [inputStyle]="{ width: '16em' }" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="2000:2030"></p-datepicker>
                            <label for="float-dd" style="width: 100%">Premium Pay End Date (and greater)</label>
                        </p-floatLabel>
                    </div>
                </p-toolbar>
            </form>
        </p-accordionTab>
        <p-accordionTab header="Manage Premium Pay">
            <p-toolbar>
                <button #addPremiumPays pButton type="button" class="p-button-secondary" aria-label="Add Premium Pays"
                    [disabled]="
                    !selected.length ||
                    selected.some(hasErrorStatus) ||
                    addFormGroup.invalid
                " icon="pi pi-plus-circle" label="Add"></button>
                <button pButton type="button" class="p-button-secondary" aria-label="Update Premium Pays"
                    [disabled]="!selected.length || selected.some(hasErrorStatus)" #updatePremiumPays
                    icon="pi pi-pencil" label="Update"></button>
                <button #deletePremiumPays pButton type="button" class="p-button-danger"
                    aria-label="Delete Premium Pays" [disabled]="!selected.length" icon="pi pi-trash"
                    label="Delete"></button>
                <div>
                    <p-message severity="info"
                        text="Select Authorizations from the grid in order to add or copy.  Start and End date are required."></p-message>
                </div>
            </p-toolbar>
            <form [formGroup]="addFormGroup" #addForm="ngForm" id="addForm">
                <p-toolbar>
                    <div>
                        <button id="btnClearFilters" class="btn btn-link" type="button" aria-label="Clear Filter"
                            #clearFilters label="Clear">
                            Clear
                        </button>
                    </div>
                    <div>
                        <p-floatLabel variant="on">
                            <p-datepicker [disabled]="!selected.length" formControlName="StartDate" dataType="string"
                                appendTo="body" [inputStyle]="{ width: '10em' }" [yearNavigator]="true"
                                [monthNavigator]="true" yearRange="2010:2030"></p-datepicker>
                            <label for="float-dd">Start Date</label>
                        </p-floatLabel>
                    </div>
                    <div>
                        <p-floatLabel variant="on">
                            <p-datepicker [disabled]="!selected.length" formControlName="EndDate" dataType="string"
                                appendTo="body" [inputStyle]="{ width: '10em' }" [yearNavigator]="true"
                                [monthNavigator]="true" yearRange="2010:2030"></p-datepicker>
                            <label for="float-dd">End Date</label>
                        </p-floatLabel>
                    </div>
                    <div *ngIf="false">
                        <p-floatLabel variant="on">
                            <input [disabled]="!selected.length" pInputText type="text" aria-label="%"
                                formControlName="PremiumPercent" />
                            <label for="float-dd">%</label>
                        </p-floatLabel>
                    </div>
                    <div>
                        <p-floatLabel variant="on">
                            <input [disabled]="!selected.length" pInputText type="text" aria-label="Amount"
                                formControlName="PremiumPay" />
                            <label for="float-dd">Amount</label>
                        </p-floatLabel>
                    </div>
                    <div>
                        <p-floatLabel variant="on">
                            <p-select *ngIf="
                                alternateTasksSelectItems
                                    | orderBy: 'label' as items;
                                else loading
                            " [disabled]="!selected.length" [options]="items" formControlName="PremiumTaskListID"
                                [filter]="true" appendTo="body" [style]="{ 'min-width': '15em' }"></p-select>
                            <label for="float-dd">Premium task</label>
                        </p-floatLabel>
                    </div>
                    <div *ngIf="false">
                        <p-floatLabel variant="on">
                            <p-select *ngIf="costTypesSelectItems as items; else loading" [disabled]="!selected.length"
                                [options]="items" formControlName="CalcType" [filter]="true" appendTo="body"></p-select>
                            <label for="float-dd">Cost Type</label>
                        </p-floatLabel>
                    </div>
                </p-toolbar>
            </form>
            <div>
                <p-messages [value]="formAddErrors"> </p-messages>
            </div>
        </p-accordionTab>
        <p-panel disabled header="Premium Pay">
            <p-toolbar>
                <div class="grid" style="width: 100%">
                    <div class="col-fixed" [ngStyle]="{
                        width: displayDetails ? '0px' : '0px',
                        padding: 0
                    }"></div>
                    <div class="col" style="padding: 0">
                        <p-toggleButton inputId="showhideDetails" [(ngModel)]="displayDetails"
                            [onLabel]="'Hide Alternate Settings'"
                            [offLabel]="'Show Alternate Settings'"></p-toggleButton>
                    </div>
                </div>
            </p-toolbar>
            <p-table stripedRows #dataTable [value]="items" dataKey="id" editMode="row" (onRowSelect)="onRowSelect($event)"
                [(selection)]="selected" [scrollable]="true" [scrollHeight]="'60vh'" [virtualScroll]="true"
                [virtualRowHeight]="dropdownItemHeight" [multiSortMeta]="[
                { field: 'TaskLongName', order: 1 },
                { field: 'EmployeeName', order: 2 },
                { field: 'ServiceItem', order: 3 },
                { field: 'EmpAuthStartDate', order: 4 },
                { field: 'EmpAuthEndDate', order: 5 }
            ]" sortMode="multiple">
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="21" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span> No Data Available </span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="21" style="text-align: center">
                            <div>
                                Loading...<i class="fa fa-spinner fa-spin"></i>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template #header let-item>
                    <tr>
                        <!-- Edit -->
                        <th class="edit-cell"></th>
                        <!-- Status-->
                        <th class="status-cell">
                            <i class="pi pi-exclamation-circle" title="Status"></i>
                        </th>
                        <!-- Selection -->
                        <th class="select-cell">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <!-- Task -->
                        <th pSortableColumn="TaskLongName">
                            Task
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="TaskLongName" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter field="TaskLongName" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                        [options]="tasksFilterSelectItems" [filter]="true"
                                        styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <!-- User -->
                        <th pSortableColumn="EmployeeName">
                            User
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="EmployeeName" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter field="EmployeeName" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                        [options]="usersSelectItems" [filter]="true"
                                        styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <!-- Service Item -->
                        <th pSortableColumn="ServiceItem">
                            Service Item
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="ServiceItem" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter field="ServiceItem" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                        [options]="serviceItemsSelectItems" [filter]="true"
                                        styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <!-- Payroll Item -->
                        <th pSortableColumn="PayrollItem">
                            Payroll Item
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="PayrollItem" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter field="PayrollItem" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                        [options]="payrollItemsFilterSelectItems" [filter]="true"
                                        styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <!-- Auth Start Date -->
                        <th pSortableColumn="authorization.EmpAuthStartDate">
                            Auth Start
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="authorization.EmpAuthStartDate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- Auth End Date -->
                        <th pSortableColumn="authorization.EmpAuthEndDate">
                            Auth End
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="authorization.EmpAuthEndDate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- PP Start Date -->
                        <th pSortableColumn="StartDate">
                            Premium Start
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="StartDate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- PP End Date -->
                        <th pSortableColumn="EndDate">
                            Premium End
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="EndDate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- % -->
                        <th *ngIf="false" pSortableColumn="PremiumPay">
                            %
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="PremiumPay" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- Amount -->
                        <th pSortableColumn="PremiumPay">
                            Amount
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="PremiumPay" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- Amount To Date -->
                        <th pSortableColumn="">
                            Amount To Date
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- Planned Amount -->
                        <th pSortableColumn="PlannedAmount">
                            Planned Amount
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="PlannedAmount" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- PP Task -->
                        <th *ngIf="displayDetails" pSortableColumn="PremiumTaskListID">
                            Premium Task
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="PremiumTaskListID" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- PP Cost Type -->
                        <th *ngIf="false" pSortableColumn="CalcType">
                            Cost Type
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="CalcType" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- Payroll Item -->
                        <th *ngIf="false" pSortableColumn="PayrollItem">
                            Payroll Item
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="PayrollItem" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- Modified Date -->
                        <th pSortableColumn="ModifiedDate">
                            Modified Date
                            <p-sortIcon
                                title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                                field="ModifiedDate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                        <!-- Delete -->
                        <th class="delete-cell"></th>
                    </tr>
                </ng-template>
                <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
                    <tr [pSelectableRow]="item" [pEditableRow]="item" data-id="row-{{ item.id }}" [ngClass]="{
                        'ui-editing-row': edit && editing?.id === item?.id
                    }">
                        <!-- Edit -->
                        <td class="edit-cell">
                            <button *ngIf="
                                    !edit &&
                                    (!editing?.id ||
                                        editing?.id === item?.id)
                                " pButton type="button" pInitEditableRow icon="pi pi-pencil"
                                class="p-button-rounded p-button-text" (click)="onRowEditInit(item)"
                                title="Edit"></button>
                            <button *ngIf="edit" pButton type="button" pSaveEditableRow icon="pi pi-check"
                                class="p-button-rounded p-button-text p-button-success"
                                (click)="onRowEditSave(item)"></button>
                            <button *ngIf="edit" pButton type="button" pCancelEditableRow icon="pi pi-times"
                                class="p-button-rounded p-button-text p-button-danger"
                                (click)="onRowEditCancel(item)"></button>

                        </td>
                        <!-- Status-->
                        <td class="status-cell">
                            <div (click)="onStatusClick(item)" class="status-cell">
                                <ef-status-icon [status]="item?.Status?.StatusCode"
                                    [message]="item?.Status?.Message"></ef-status-icon>
                            </div>
                        </td>
                        <!-- Selection -->
                        <td class="select-cell">
                            <p-tableCheckbox [value]="item"></p-tableCheckbox>
                        </td>

                        <!-- Task -->
                        <td class="disabled" [title]="item?.TaskLongName">
                            {{ item?.TaskLongName }}
                        </td>
                        <!-- User -->
                        <td class="disabled" [title]="item?.EmployeeName">
                            {{ item?.EmployeeName }}
                        </td>
                        <!-- Service Item -->
                        <td class="disabled" [title]="item?.ServiceItem">
                            {{ item?.ServiceItem }}
                        </td>
                        <!-- PayrollItem -->
                        <td class="disabled" [title]="item?.PayrollItem">
                            {{ item?.PayrollItem }}
                        </td>
                        <!-- Auth Start Date -->
                        <td class="disabled" [title]="
                            moment(
                                item?.authorization?.EmpAuthStartDate
                            ).format('MM/DD/YYYY')
                        ">
                            {{
                            moment(
                            item?.authorization?.EmpAuthStartDate
                            ).format('MM/DD/YYYY')
                            }}
                        </td>
                        <!-- Auth End Date -->
                        <td class="disabled" [title]="
                            moment(
                                item?.authorization?.EmpAuthEndDate
                            ).format('MM/DD/YYYY')
                        ">
                            {{
                            moment(
                            item?.authorization?.EmpAuthEndDate
                            ).format('MM/DD/YYYY')
                            }}
                        </td>
                        <!-- PP Start Date -->
                        <td [title]="
                            moment(item?.StartDate).format('MM/DD/YYYY')
                        ">
                            <p-cellEditor>
                                <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                    <p-datepicker [monthNavigator]="true" [yearNavigator]="true" [minDate]="
                                        item?.authorization
                                            ?.EmpAuthStartDate
                                    " [maxDate]="
                                        getMinDate(
                                            item?.authorization
                                                ?.EmpAuthEndDate,
                                            item?.EndDate
                                        )
                                    " yearRange="2000:2030" [(ngModel)]="item.StartDate" appendTo="body"></p-datepicker>
                                </ng-template>
                                <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                    {{
                                    moment(item?.StartDate).format(
                                    'MM/DD/YYYY'
                                    )
                                    }}
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{
                                    moment(item?.StartDate).format(
                                    'MM/DD/YYYY'
                                    )
                                    }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <!-- PP End Date -->
                        <td [title]="moment(item?.EndDate).format('MM/DD/YYYY')">
                            <p-cellEditor>
                                <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                    <p-datepicker [monthNavigator]="true" [yearNavigator]="true" [minDate]="
                                        getMaxDate(
                                            item?.authorization
                                                ?.EmpAuthStartDate,
                                            item?.StartDate
                                        )
                                    " [maxDate]="
                                        item?.authorization?.EmpAuthEndDate
                                    " yearRange="2000:2030" [(ngModel)]="item.EndDate" appendTo="body"></p-datepicker>
                                </ng-template>
                                <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                    {{
                                    moment(item?.EndDate).format(
                                    'MM/DD/YYYY'
                                    )
                                    }}
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{
                                    moment(item?.EndDate).format(
                                    'MM/DD/YYYY'
                                    )
                                    }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <!-- % -->
                        <td *ngIf="false" [title]="item?.PremiumPercent">
                            <p-cellEditor>
                                <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                    <input pInputText [(ngModel)]="item.PremiumPercent" />
                                </ng-template>
                                <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                    {{ item?.PremiumPercent }}
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ item?.PremiumPercent }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <!-- Amount -->
                        <td>
                            <p-cellEditor>
                                <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                    <input pInputText [(ngModel)]="item.PremiumPay" />
                                </ng-template>
                                <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                    {{ item?.PremiumPay }}
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ item?.PremiumPay }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <!-- Amount To Date -->
                        <td class="disabled" [title]="item?.AmountToDate">
                            {{ item?.AmountToDate }}
                        </td>
                        <!-- Planned Amount -->
                        <td [title]="item?.PlannedAmount">
                            <p-cellEditor>
                                <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                    <input pInputText [(ngModel)]="item.PlannedAmount" />
                                </ng-template>
                                <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                    {{ item?.PlannedAmount }}
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ item?.PlannedAmount }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <!-- PP Task/Alternate Task -->
                        <td *ngIf="displayDetails" [title]="
                            (
                                tasks
                                | itemlookup
                                    : 'TaskListID'
                                    : item?.PremiumTaskListID
                            )?.TaskLongName
                        ">
                            <p-cellEditor>
                                <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                    <p-select [style]="{ width: '100%' }" [virtualScroll]="true"
                                        [itemSize]="dropdownItemHeight" [options]="
                                        alternateTasksSelectItems
                                            | orderBy: 'label'
                                    " [autoDisplayFirst]="false" appendTo="body" [(ngModel)]="item.PremiumTaskListID"
                                        defaultLabel="Task" [filter]="true"></p-select>
                                </ng-template>
                                <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                    {{
                                    (
                                    tasks
                                    | itemlookup
                                    : 'TaskListID'
                                    : item?.PremiumTaskListID
                                    )?.TaskLongName
                                    }}
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{
                                    (
                                    tasks
                                    | itemlookup
                                    : 'TaskListID'
                                    : item?.PremiumTaskListID
                                    )?.TaskLongName
                                    }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <!-- PP Cost Type -->
                        <td *ngIf="false" [title]="item?.CalcType">
                            <p-cellEditor>
                                <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                    <p-select [style]="{ width: '100%' }" [virtualScroll]="true"
                                        [itemSize]="dropdownItemHeight" [options]="costTypesSelectItems"
                                        [autoDisplayFirst]="false" appendTo="body" [(ngModel)]="item.CalcType"
                                        defaultLabel="Cost Type" [filter]="true"></p-select>
                                </ng-template>
                                <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                    {{ item?.CalcType }}
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ item?.CalcType }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <!-- PayrollItem -->
                        <td *ngIf="false" [title]="item?.CalcType">
                            <p-cellEditor>
                                <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                                    <p-select [style]="{ width: '100%' }" [virtualScroll]="true"
                                        [itemSize]="dropdownItemHeight" [options]="payrollItemsSelectItems"
                                        [autoDisplayFirst]="false" appendTo="body" [(ngModel)]="item.PremiumPIListID"
                                        defaultLabel="Cost Type" [filter]="true"></p-select>
                                </ng-template>
                                <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                                    {{
                                    (
                                    payrollItemsSelectItems
                                    | itemlookup
                                    : 'value'
                                    : item?.PremiumPIListID
                                    )?.PayrollItem
                                    }}
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{
                                    (
                                    payrollItemsSelectItems
                                    | itemlookup
                                    : 'value'
                                    : item?.PremiumPIListID
                                    )?.PayrollItem
                                    }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <!-- Modified Date -->
                        <td class="disabled" [title]="
                            moment(item?.ModifiedDate).format('MM/DD/YYYY')
                        ">
                            {{
                            moment(item?.ModifiedDate).format('MM/DD/YYYY')
                            }}
                        </td>
                        <!-- Delete -->
                        <td class="delete-cell">
                            <button *ngIf="item?.id !== 'add' && !edit" pButton type="button" pSaveEditableRow
                                icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger"
                                (click)="onRowEditDelete(item, ri)" style="font-size: 0.65rem"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-panel>
    </p-accordion>
</div>
